import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Wordmark from '../components/Wordmark';
import { sty } from './DemoPage.styles';

// ── Data ──────────────────────────────────────────────────────────────────────

const DEMO_CELLS = [
  { word: 'Olympus',   state: 'marked'  },
  { word: 'Medusa',    state: 'default' },
  { word: 'satyr',     state: 'marked'  },
  { word: 'oracle',    state: 'default' },
  { word: 'Chiron',    state: 'default' },
  { word: 'Minotaur',  state: 'default' },
  { word: 'cyclops',   state: 'marked'  },
  { word: 'Poseidon',  state: 'default' },
  { word: 'Athena',    state: 'marked'  },
  { word: 'demigod',   state: 'default' },
  { word: 'labyrinth', state: 'default' },
  { word: 'ambrosia',  state: 'marked'  },
  { word: 'FREE',      state: 'free'    },
  { word: 'Olympian',  state: 'default' },
  { word: 'Annabeth',  state: 'default' },
  { word: 'Grover',    state: 'default' },
  { word: 'Thalia',    state: 'marked'  },
  { word: 'ephemeral', state: 'marked'  },
  { word: 'prophecy',  state: 'default' },
  { word: 'Kronos',    state: 'default' },
  { word: 'Tartarus',  state: 'default' },
  { word: 'Elysium',   state: 'default' },
  { word: 'Hermes',    state: 'marked'  },
  { word: 'Percy',     state: 'default' },
  { word: 'Riptide',   state: 'marked'  },
];

// Every clue is a word on the demo board (The Lightning Thief), so it can be found and marked.
const TEACHER_CLUES = ['ephemeral', 'prophecy', 'labyrinth', 'demigod', 'Minotaur'];
const INIT_PREV_CALLED = ['Olympus', 'satyr', 'cyclops', 'Athena'];
const ROSTER = ['Alex', 'Jordan', 'Sam', 'Maya', 'Chris'];

// Pre-marked indices in student demo: marked + free cells from DEMO_CELLS
const INIT_MARKED = new Set([0, 2, 6, 8, 11, 12, 16, 22, 24]);


// ── Icons ─────────────────────────────────────────────────────────────────────

function IconPresentation() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
      stroke="#006D77" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="13" rx="1" />
      <path d="M8 21l4-4 4 4" />
      <line x1="12" y1="16" x2="12" y2="21" />
    </svg>
  );
}

function IconTable() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
      stroke="#FF6B6B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="16" rx="1" />
      <line x1="3" y1="11" x2="21" y2="11" />
      <line x1="3" y1="17" x2="21" y2="17" />
      <line x1="9" y1="5" x2="9" y2="21" />
      <line x1="15" y1="5" x2="15" y2="21" />
    </svg>
  );
}

// ── Nav ───────────────────────────────────────────────────────────────────────

function DemoNav() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <nav style={sty.nav}>
        <style>{`
          .dn-desktop { display: flex; }
          .dn-burger   { display: none; }
          @media (max-width: 640px) {
            .dn-desktop { display: none !important; }
            .dn-burger   { display: flex !important; }
          }
          .dn-ham { display: block; width: 22px; height: 2px; background: #1B1B2F; border-radius: 2px; transition: transform 0.25s ease, opacity 0.2s ease; }
          .dn-ham-top.open { transform: translateY(7px) rotate(45deg); }
          .dn-ham-mid.open { opacity: 0; transform: scaleX(0); }
          .dn-ham-bot.open { transform: translateY(-7px) rotate(-45deg); }
          .dn-overlay { position: fixed; top: 60px; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.4); z-index: 200; opacity: 0; pointer-events: none; transition: opacity 0.25s; }
          .dn-overlay.open { opacity: 1; pointer-events: auto; }
          .dn-drawer { position: fixed; top: 60px; right: 0; height: calc(100vh - 60px); width: 280px; max-width: 85vw; background: #fff; z-index: 201; box-shadow: -4px 0 24px rgba(0,0,0,0.1); transform: translateX(100%); transition: transform 0.28s cubic-bezier(0.4,0,0.2,1); }
          .dn-drawer.open { transform: translateX(0); }
        `}</style>
        <div style={sty.navInner}>
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Wordmark style={{ fontSize: '20px' }} />
          </Link>
          <div className="dn-desktop" style={sty.navRight}>
            <span style={sty.demoPill}>Demo mode</span>
            <Link to="/signup" style={sty.navCta}>Sign up — $19.99/yr</Link>
          </div>
          <button
            className="dn-burger"
            style={sty.hamburgerBtn}
            onClick={() => setOpen(o => !o)}
            aria-label={open ? 'Close menu' : 'Open menu'}
          >
            <span className={`dn-ham dn-ham-top${open ? ' open' : ''}`} />
            <span className={`dn-ham dn-ham-mid${open ? ' open' : ''}`} />
            <span className={`dn-ham dn-ham-bot${open ? ' open' : ''}`} />
          </button>
        </div>
      </nav>
      <div className={`dn-overlay${open ? ' open' : ''}`} onClick={close} />
      <div className={`dn-drawer${open ? ' open' : ''}`}>
        <div style={sty.drawerContent}>
          <span style={sty.demoPill}>Demo mode</span>
          <Link to="/signup" style={sty.drawerCta} onClick={close}>Sign up — $19.99/yr</Link>
        </div>
      </div>
    </>
  );
}

// ── Footer ────────────────────────────────────────────────────────────────────

function DemoFooter() {
  return (
    <footer style={sty.footer}>
      <style>{`.df-link:hover { color: #1B1B2F !important; }`}</style>
      <Wordmark style={{ fontSize: '20px' }} />
      <nav style={sty.footerNav}>
        <Link to="/privacy" className="df-link" style={sty.footerLink}>Privacy</Link>
        <Link to="/terms"   className="df-link" style={sty.footerLink}>Terms</Link>
        <a href="mailto:hello@classroom.bingo" className="df-link" style={sty.footerLink}>Contact</a>
      </nav>
      <span style={sty.footerCopy}>© 2025 Classroom.Bingo</span>
    </footer>
  );
}

// ── Sticky Bar ────────────────────────────────────────────────────────────────

function StickyBar() {
  return (
    <div style={sty.stickyBar}>
      <div style={sty.stickyLeft}>
        <span style={sty.stickyPill}>Demo</span>
        <span style={sty.stickyText}>Exploring classroom.bingo — no account needed</span>
      </div>
      <Link to="/signup" style={sty.stickySignup}>Sign up — $19.99/yr →</Link>
    </div>
  );
}

// ── Entry View ────────────────────────────────────────────────────────────────

function EntryView({ onSelect }) {
  return (
    <>
      <style>{`
        .demo-role-card {
          background: #fff; border-radius: 16px; padding: 28px 24px 22px;
          border: 2px solid transparent; cursor: pointer; position: relative;
          text-align: left; transition: border-color 0.18s;
          display: flex; flex-direction: column;
        }
        .demo-role-card:hover { border-color: #83C5BE; }
        @media (max-width: 640px) {
          .demo-role-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* Hero */}
      <section style={sty.heroSection}>
        <div style={sty.heroContent}>
          <div style={sty.heroEyebrow}>Interactive demo</div>
          <h1 style={sty.heroH1}>See it from both sides</h1>
          <p style={sty.heroSub}>Pick a role and explore the real product. No account needed.</p>

          <div className="demo-role-grid" style={sty.roleGrid}>
            {/* Teacher card */}
            <div className="demo-role-card" onClick={() => onSelect('teacher')}>
              <span style={sty.startBadge}>Start here</span>
              <div style={sty.iconCircle('#EDF6F9')}>
                <IconPresentation />
              </div>
              <div style={sty.roleTitle}>I'm a Teacher</div>
              <div style={sty.roleDesc}>
                Set up a game in seconds — choose your word list, start the session, and call clues one at a time while students race to fill their boards. Monitor the live roster and follow along when someone hits BINGO.
              </div>
              <ul style={sty.roleFeatures}>
                <li>Call vocabulary clues live</li>
                <li>See who's connected in real time</li>
                <li>End or reset the game anytime</li>
              </ul>
              <button
                style={sty.roleBtnTeacher}
                onClick={e => { e.stopPropagation(); onSelect('teacher'); }}
              >
                Teacher demo →
              </button>
            </div>

            {/* Student card */}
            <div className="demo-role-card" onClick={() => onSelect('student')}>
              <div style={sty.iconCircle('#fff3f3')}>
                <IconTable />
              </div>
              <div style={sty.roleTitle}>I'm a Student</div>
              <div style={sty.roleDesc}>
                Join your teacher's live game and get a uniquely shuffled bingo board. Listen for each clue, tap the matching word, and be the first to land five in a row — then shout BINGO!
              </div>
              <ul style={sty.roleFeatures}>
                <li>Randomized board every game</li>
                <li>Tap to mark matching words</li>
                <li>Strike counter keeps play fair</li>
              </ul>
              <button
                style={sty.roleBtnStudent}
                onClick={e => { e.stopPropagation(); onSelect('student'); }}
              >
                Student demo →
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

// ── Teacher Demo ──────────────────────────────────────────────────────────────

function TeacherDemo({ onBack }) {
  const [clueIdx, setClueIdx]       = useState(0);
  const [prevCalled, setPrevCalled] = useState([...INIT_PREV_CALLED]);
  const [histOpen, setHistOpen]     = useState(false);

  const currentClue = TEACHER_CLUES[clueIdx];

  function handleNextClue() {
    setPrevCalled(prev => [...prev, TEACHER_CLUES[clueIdx]]);
    setClueIdx(i => (i + 1) % TEACHER_CLUES.length);
  }

  return (
    <div style={sty.viewPage}>
      <div style={sty.teacherInner}>
        <button onClick={onBack} style={sty.backLink}>← Back to demo home</button>

        <div style={sty.teacherCard}>
          {/* Header */}
          <div style={sty.cardHeaderRow}>
            <span style={sty.cardMeta}>Mrs. Garcia's Class</span>
            <span style={sty.cardMeta}>The Lightning Thief</span>
          </div>

          {/* Current clue */}
          <div style={sty.clueCard}>
            <div>
              <div style={sty.clueCardLabel}>CURRENT CLUE</div>
              <div style={sty.clueCardWord}>{currentClue}</div>
            </div>
          </div>

          {/* Next clue button */}
          <button onClick={handleNextClue} style={sty.nextClueBtn}>Next Clue →</button>

          {/* Collapsible history */}
          <div style={{ marginBottom: '20px' }}>
            <button
              onClick={() => setHistOpen(o => !o)}
              style={sty.histToggle}
            >
              <span>Previously called ({prevCalled.length})</span>
              <span>{histOpen ? '▲' : '▼'}</span>
            </button>
            {histOpen && (
              <div style={sty.histList}>
                {[...prevCalled].reverse().map((w, i) => (
                  <span key={i} style={sty.histWord}>{w}</span>
                ))}
              </div>
            )}
          </div>

          {/* Student roster */}
          <div style={{ marginBottom: '20px' }}>
            <div style={sty.rosterHeading}>Students</div>
            {ROSTER.map(name => (
              <div key={name} style={sty.rosterRow}>
                <span style={sty.greenDot} />
                <span style={sty.rosterName}>{name}</span>
                <span style={sty.rosterStatus}>connected</span>
              </div>
            ))}
          </div>

          {/* Disabled controls */}
          <div style={sty.disabledRow}>
            <span title="Available in full version" style={{ cursor: 'not-allowed', display: 'inline-block' }}>
              <button disabled style={sty.disabledBtn}>End Game</button>
            </span>
            <span title="Available in full version" style={{ cursor: 'not-allowed', display: 'inline-block' }}>
              <button disabled style={sty.disabledBtn}>Reset</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Student Demo ──────────────────────────────────────────────────────────────

function StudentDemo({ onBack }) {
  const [marked, setMarked]               = useState(new Set(INIT_MARKED));
  const [currentClue, setCurrentClue]     = useState('ephemeral');
  const [incorrectSet, setIncorrectSet]   = useState(new Set());
  const [strikes, setStrikes]             = useState(0);

  // Auto-advance to the second clue after 6 seconds
  useEffect(() => {
    const t = setTimeout(() => {
      setCurrentClue(TEACHER_CLUES[1]);
      setIncorrectSet(new Set());
      setStrikes(0);
    }, 6000);
    return () => clearTimeout(t);
  }, []);

  function handleCellClick(idx) {
    if (idx === 12) return; // FREE cell
    const cell = DEMO_CELLS[idx];
    if (!cell) return;

    if (marked.has(idx)) {
      // Toggle off
      const next = new Set(marked);
      next.delete(idx);
      setMarked(next);
      return;
    }

    // Like the real card: 3 wrong marks lock the board until the next clue,
    // and a square already marked wrong for this clue doesn't count again.
    if (strikes >= 3 || incorrectSet.has(idx)) return;

    if (cell.word === currentClue) {
      // Correct mark
      setMarked(prev => new Set([...prev, idx]));
    } else {
      // Incorrect mark
      setStrikes(strikes + 1);
      setIncorrectSet(prev => new Set([...prev, idx]));
    }
  }

  return (
    <div style={sty.viewPage}>
      <div style={sty.studentInner}>
        <button onClick={onBack} style={sty.backLink}>← Back to demo home</button>

        <div style={sty.studentCard}>
        {/* Header */}
        <div style={sty.cardHeaderRow}>
          <span style={{ ...sty.cardMeta, color: 'rgba(255,255,255,0.7)' }}>Mrs. Garcia's Class</span>
          <span style={{ ...sty.cardMeta, color: 'rgba(255,255,255,0.7)' }}>Room: B7F3</span>
          <span style={{ ...sty.cardMeta, color: 'rgba(255,255,255,0.7)' }}>Alex</span>
        </div>

        {/* Current clue */}
        <div style={sty.clueCard}>
          <div>
            <div style={sty.clueCardLabel}>CURRENT CLUE</div>
            <div style={sty.clueCardWord}>{currentClue}</div>
          </div>
          <div style={sty.winPattern}>
            <div style={sty.winPatternLabel}>WIN PATTERN</div>
            <div style={sty.winPatternGrid}>
              {Array.from({ length: 25 }, (_, i) => {
                const s = i === 12 ? sty.winCellFree : Math.floor(i / 5) === 0 ? sty.winCellOn : sty.winCellOff;
                return <div key={i} style={s} />;
              })}
            </div>
            <div style={sty.winPatternName}>LINE</div>
          </div>
        </div>

        {/* 5×5 board */}
        <div style={sty.studentGrid}>
          {DEMO_CELLS.map((cell, i) => {
            const isFree     = i === 12;
            const isMarked   = marked.has(i);
            const isIncorrect = incorrectSet.has(i) && !isMarked;

            let cellStyle = { ...sty.studentCell };
            if (isMarked)    cellStyle = { ...cellStyle, ...sty.studentCellMarked };
            if (isFree)      cellStyle = { ...cellStyle, ...sty.studentCellFree };
            if (isIncorrect) cellStyle = { ...cellStyle, border: '1.5px solid #FF6B6B' };

            return (
              <div
                key={i}
                style={cellStyle}
                onClick={() => handleCellClick(i)}
                role={isFree ? undefined : 'button'}
                tabIndex={isFree ? undefined : 0}
                onKeyDown={e => { if (!isFree && (e.key === 'Enter' || e.key === ' ')) handleCellClick(i); }}
              >
                {cell.word}
              </div>
            );
          })}
        </div>

        {/* Strike counter */}
        {strikes > 0 && (
          <p style={sty.strikeCounter}>
            {strikes}/3 incorrect marks{strikes >= 3 ? ' — wait for the next word.' : ''}
          </p>
        )}

        {/* BINGO button */}
        <div style={{ marginTop: '20px' }}>
          <button disabled style={sty.studentBingoBtn}>BINGO!</button>
          <p style={{ ...sty.bingoNote, color: 'rgba(255,255,255,0.5)' }}>Bingo not available in demo</p>
        </div>
        </div>{/* /studentCard */}
      </div>
    </div>
  );
}

// ── Page ──────────────────────────────────────────────────────────────────────

export default function DemoPage() {
  const [view, setView] = useState('entry'); // 'entry' | 'teacher' | 'student'

  return (
    <div style={sty.page}>
      <DemoNav />
      {view === 'entry'   && <EntryView   onSelect={setView} />}
      {view === 'teacher' && <TeacherDemo onBack={() => setView('entry')} />}
      {view === 'student' && <StudentDemo onBack={() => setView('entry')} />}
      <DemoFooter />
      <StickyBar />
    </div>
  );
}
